import { Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutReverseTransferSettlementWarningsAndExceptionsTable extends Layout {
    tableWarningsAndExceptions: Table;
}
